module.exports = __webpack_public_path__ + "img/course-1.ed956e39.png";